import { useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { InputNumber } from "antd";

import routeNames from "constants/route-names";
import { useLoggedUser } from "state/reactive-vars/logged-user-var";
import { useCartStatus } from "state/reactive-vars/cart-status-var";

interface CartContentProps {}

const CartContent = (props: CartContentProps) => {
  const { loggedUserValue } = useLoggedUser();
  const navigate = useNavigate();
  const { cartStatusValue, updateQuantity, removeFromCart } = useCartStatus();

  const goToCheckout = useCallback(() => {
    navigate(routeNames.CHECKOUT);
  }, []);

  if (!cartStatusValue.items.length) {
    return (
      <>
        <div className="property-list-empty">
          <img src={`${process.env.PUBLIC_URL}/assets/images/icons/basket-in-circle.svg`} />
          <span>Your cart is empty.</span>
        </div>

        <Link
          to={routeNames.ORDER}
          className="notifications-view-more"
        >
          Start an order{" "}
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/icons/external-link-red.svg`}
          />
        </Link>
      </>
    )
  }

  return (
    <div className="cart-container">
      <div className="cart-items-container">
        {cartStatusValue.items.map((element) => {
          const { product, property, quantity, totalPrice } = element;
          const { name, photo_link = "" } = product || {};
          const { name: propertyName } = property || {};

          return (
            <div className="cart-item">
              <div
                className="cart-item-photo"
                style={
                  photo_link
                    ? {
                        backgroundImage: `url(${photo_link})`,
                      }
                    : {}
                }
              ></div>

              <div className="cart-item-info">
                <span className="cart-item-name">{name}</span>
                {loggedUserValue.organization?.display_price ? (
                  <span className="cart-item-price">{totalPrice}</span>
                ) : null}
                <span className="cart-item-property">{propertyName}</span>
              </div>

              <div className="cart-item-actions-container">
                <img
                  alt={`remove-attachment-icon`}
                  src={`${process.env.PUBLIC_URL}/assets/images/icons/remove-trash.svg`}
                  className="cart-remove-item"
                  onClick={() => removeFromCart(product.id, property.id)}
                />
                <InputNumber
                  name="quantity"
                  placeholder="Quantity"
                  className="cart-item-input"
                  value={quantity}
                  onChange={(value) => {
                    if (value) {
                      updateQuantity(product.id, property.id, value);
                    }
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>

      {cartStatusValue.totalItems ? (
        <button className="product-d-button" onClick={goToCheckout}>
          Submit Order Request
        </button>
      ) : null}
    </div>
  );
};

export default CartContent;
